import {
  Home,
  Mail,
  User2,
  FileText,
  Settings,
  ChartColumn,
  FileChartColumnIncreasing,
} from "lucide-react";

export const sidebarList = {
  seller: [
    {
      title: "Home",
      url: "/home",
      icon: Home,
    },
    {
      title: "Submit Offer",
      url: "/seller-form",
      icon: FileChartColumnIncreasing,
    },
    {
      title: "Track Request",
      url: "/products",
      icon: ChartColumn,
    },
    {
      title: "Profile",
      url: "/profile",
      icon: User2,
    },
  ],
  buyer: [
    {
      title: "Home",
      url: "/home",
      icon: Home,
    },
    {
      title: "Request Material",
      url: "/buyer-form",
      icon: FileChartColumnIncreasing,
    },
    {
      title: "Explore Products",
      url: "/products",
      icon: ChartColumn,
    },
    {
      title: "Profile",
      url: "/profile",
      icon: User2,
    },
  ],
  seller_agent: [
    {
      title: "Home",
      url: "/home",
      icon: Home,
    },
    {
      title: "Submit Offer",
      url: "/seller-form",
      icon: FileChartColumnIncreasing,
    },
    {
      title: "Manage Requests",
      url: "/requests",
      icon: ChartColumn,
    },
    {
      title: "Manage Client",
      url: "/register",
      icon: User2,
    },
    {
      title: "Documentation",
      url: "/documentation",
      icon: FileText,
    },
    {
      title: "Profile",
      url: "/profile",
      icon: User2,
    },
  ],
  buyer_agent: [
    {
      title: "Home",
      url: "/home",
      icon: Home,
    },
    {
      title: "Request Material",
      url: "/buyer-form",
      icon: FileChartColumnIncreasing,
    },
    {
      title: "Manage Requests",
      url: "/requests",
      icon: ChartColumn,
    },
    {
      title: "Manage Client",
      url: "/register",
      icon: User2,
    },
    {
      title: "Documentation",
      url: "/documentation",
      icon: FileText,
    },
    {
      title: "Profile",
      url: "/profile",
      icon: User2,
    },
  ],
  admin: [
    {
      title: "Dashboard",
      url: "/admin",
      icon: ChartColumn,
    },
    {
      title: "Manage Clients",
      url: "/admin/clients",
      icon: User2,
    },
    {
      title: "Manage Agents",
      url: "/admin/agents",
      icon: User2,
    },
    {
      title: "Create Request",
      url: "/admin/offer",
      icon: FileChartColumnIncreasing,
    },
    {
      title: "Manage Requests",
      url: "/admin/requests",
      icon: ChartColumn,
    },
    {
      title: "Archived Requests",
      url: "/admin/archived",
      icon: ChartColumn,
    },
    {
      title: "Email Marketing",
      url: "/admin/emails",
      icon: Mail,
    },
    {
      title: "Documentation",
      url: "/documentation",
      icon: FileText,
    },
    {
      title: "Settings",
      url: "/admin/settings",
      icon: Settings,
    },
  ],
};
